import { call, put, select, spawn, take } from 'redux-saga/effects';

import { actions, types } from '@elab/core/store/wishlist';
import {
    actions as globalActions,
    selectors as globalSelectors,
    types as globalTypes,
} from '@elab/core/store/global';
import { selectors as configSelectors } from '@elab/core/store/config';
import { types as authTypes } from '@elab/core/store/auth';
import { actions as uiActions, selectors as uiSelectors } from '@elab/core/store/ui';
import { deleteCookie, getCookie, setCookie } from '@elab/core/utils/cookie';
import { application } from '@elab/core/utils/appData';
import * as address from '@elab/core/utils/address';
import { getLoginRedirectURL } from '@elab/core/utils/appNavigation';

import { setWishProductCookie } from '../helpers';

const IS_PLP_PAGETYPE = 'isPlpPageType';
const GET_REDIRECTION_URL = 'getRedirectionUrl';

export function* afterGuestLoggedInHandler() {
    yield take(authTypes.LOGIN_PROFILE_READY);

    const shouldRedirectToPDPAfterLogin = select(configSelectors.shouldRedirectToPDPAfterLogin);
    if (shouldRedirectToPDPAfterLogin) {
        yield take(globalTypes.PAGE_LOAD);
    }

    const multipleWishlistsEnabled = yield select(globalSelectors.multipleWishlistsEnabled);
    if (!multipleWishlistsEnabled) {
        yield put(actions.loadWishlist());
        yield take(types.LOADING_FINISHED);
    }

    yield put(uiActions.closeDialog({ name: 'login-popup' }));
    const productCookieName = `${application.baseSiteId}-wishlist`;
    const productCode = yield call(getCookie, productCookieName);
    const addAfterUserLogin = yield select(configSelectors.addProductAfterUserLogin);
    const sendProductData = yield select(configSelectors.sendAnalyticsFullProductData);
    let analytics = {};
    if (sendProductData) {
        const analyticsData = yield call(getCookie, `${productCookieName}-data`);
        analytics = JSON.parse(analyticsData);
    }

    if (!multipleWishlistsEnabled || addAfterUserLogin) {
        yield put(actions.addToWishlist({ productCode, analytics }));
    }
    yield call(deleteCookie, productCookieName);
    const isPlpPage = localStorage.getItem(IS_PLP_PAGETYPE);
    if (isPlpPage) {
        window.location = localStorage.getItem(GET_REDIRECTION_URL);
    }
}

// redirects guest to login page after 'add to wishlist' action
// [Applied on: KV, ICI, MRN, WTC]
function* redirect(productCode, egiftcard, analytics, isPlpPageType) {
    const sendProductData = yield select(configSelectors.sendAnalyticsFullProductData);
    if (sendProductData) {
        yield call(
            setCookie,
            `${application.baseSiteId}-wishlist-data`,
            JSON.stringify(analytics),
            1,
        );
    }
    yield call(setWishProductCookie, productCode);
    const shouldRedirectToPDPAfterLogin = yield select(
        configSelectors.shouldRedirectToPDPAfterLogin,
    );

    if (shouldRedirectToPDPAfterLogin) {
        const currentURL = yield call(address.getURL);
        yield put(globalActions.setPrevPageData({ isEGiftCard: egiftcard, url: currentURL }));
        if (isPlpPageType) {
            localStorage.setItem(GET_REDIRECTION_URL, currentURL);
            localStorage.setItem(IS_PLP_PAGETYPE, true);
        }
    }

    const redirectURL = yield call(getLoginRedirectURL);
    const dialogName = yield select(uiSelectors.getDialogName);
    if (dialogName === 'product-details-popup') {
        yield put(uiActions.closeDialog());
    }

    yield put(globalActions.redirect({ successRedirectUrl: redirectURL }));
    yield spawn(afterGuestLoggedInHandler);
}

export const addToWishlistGuestStrategies = { redirect };
